import * as React from 'react'

import { deriveTabs } from './deriveTabs'
import { type GlobalSearchResult } from '../../../../value-objects/GlobalSearchResult'
import { type GlobalSearchResultItem } from '../../../../value-objects/GlobalSearchResultItem'
import {
  GlobalSearchTabTypes,
  type GlobalSearchTab,
  type GlobalSearchTabTypeEnum,
} from '../../enums/GlobalSearchTabTypeEnum'

interface IUseGlobalSearchTabStateResult {
  selectedTab: GlobalSearchTabTypeEnum
  selectTab: (type: GlobalSearchTabTypeEnum) => void
  filteredResultItems: GlobalSearchResultItem[]
  tabs: Nullable<GlobalSearchTab[]>
  resetTab: () => void
}

export const useGlobalSearchTabState = (
  searchResult: GlobalSearchResult | undefined
): IUseGlobalSearchTabStateResult => {
  const [selectedTab, setSelectedTab] = React.useState<GlobalSearchTabTypeEnum>(
    GlobalSearchTabTypes.ALL
  )

  const tabs = React.useMemo(
    () => deriveTabs(searchResult ?? null),
    [searchResult]
  )

  const filteredResultItems = React.useMemo(() => {
    if (!searchResult) return []
    if (selectedTab === GlobalSearchTabTypes.ALL) return searchResult.items
    return searchResult.items.filter((item) => item.type === selectedTab)
  }, [searchResult, selectedTab])

  const selectTab = React.useCallback((type: GlobalSearchTabTypeEnum) => {
    setSelectedTab(type)
  }, [])

  const resetTab = React.useCallback(() => {
    setSelectedTab(GlobalSearchTabTypes.ALL)
  }, [])

  return {
    selectedTab,
    selectTab,
    filteredResultItems,
    tabs,
    resetTab,
  }
}
